module.exports = __webpack_public_path__ + "img/edit.bcb13399.svg";